import { Link } from "react-router-dom";
 const regex = /^(null)+$/;
 const ResultsTable = ({ documents }) => {
   return (
     <div className="results">
       <h2>Wyniki wyszukiwania</h2>
       <table>
         <thead>
           <tr>
             <th>Numer</th>
             <th>Nazwa dokumentu</th>
             <th>Znak Sprawy</th>
             <th>Data modyfikacji</th>
             <th>Data publikacji</th>
             <th>Urząd</th>
             <th>Dokument wytworzył</th>
             <th>Akcja</th>
           </tr>
         </thead>
         <tbody>
           {documents.map((doc, index) => (
             <tr key={index}>
               <td>{doc.CARD_NUMBER}</td>
               <td>{doc.NAME}</td>
               <td>{doc.CASE_MARK}</td>
               <td>{doc.MODIFICATION_DATE}</td>
               <td>{doc.PUBLISH_DATE}</td>
               <td>{doc.OFFICE_NAME}</td>
               <td>{regex.test(doc.CREATE_DOMAIN_TEXT)? "***************": doc.CREATE_DOMAIN_TEXT}</td>
               <td><Link to={`/dokument/${doc.ID_CARD}`}>Podgląd</Link></td>
             </tr>
           ))}
         </tbody>
       </table>
     </div>
   );
 };

 export default ResultsTable;
